import { RecallType } from "./RecallType";

export abstract class RecalledValue {
    abstract evaluateProperty(
        mode: RecallType,
        property: string,
        parameters: string[],
    ): string | RecalledValue;
    abstract toCode(): string;
    abstract toText(): string;

    toString(mode: RecallType) {
        return mode === RecallType.Code ? this.toCode() : this.toText();
    }
}
